var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerif(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 118,
    height: 92,
    viewBox: "0 0 118 92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2345",
    "data-name": "Rectangle 2345",
    width: 118,
    height: 92,
    transform: "translate(0.256 -0.5)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2313",
    "data-name": "Rectangle 2313",
    width: 21.027,
    height: 6.978,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2314",
    "data-name": "Rectangle 2314",
    width: 28.619,
    height: 10.232,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2315",
    "data-name": "Rectangle 2315",
    width: 15.689,
    height: 21.992,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2316",
    "data-name": "Rectangle 2316",
    width: 19.658,
    height: 10.654,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2317",
    "data-name": "Rectangle 2317",
    width: 24.871,
    height: 15.775,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2318",
    "data-name": "Rectangle 2318",
    width: 8.533,
    height: 9.127,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2319",
    "data-name": "Rectangle 2319",
    width: 6.541,
    height: 6.996,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2320",
    "data-name": "Rectangle 2320",
    width: 61.106,
    height: 6.63,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2323",
    "data-name": "Rectangle 2323",
    width: 16.581,
    height: 2.283,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2324",
    "data-name": "Rectangle 2324",
    width: 33.999,
    height: 33.997,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2325",
    "data-name": "Rectangle 2325",
    width: 27.388,
    height: 23.379,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2326",
    "data-name": "Rectangle 2326",
    width: 30.145,
    height: 26.225,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2328",
    "data-name": "Rectangle 2328",
    width: 29.069,
    height: 12.611,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2329",
    "data-name": "Rectangle 2329",
    width: 61.801,
    height: 42.041,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2330",
    "data-name": "Rectangle 2330",
    width: 6.029,
    height: 1.831,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2331",
    "data-name": "Rectangle 2331",
    width: 13.424,
    height: 31.461,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2332",
    "data-name": "Rectangle 2332",
    width: 1.652,
    height: 14.036,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2333",
    "data-name": "Rectangle 2333",
    width: 4.047,
    height: 2.739,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-22"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2334",
    "data-name": "Rectangle 2334",
    width: 8.906,
    height: 36.275,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-23"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2335",
    "data-name": "Rectangle 2335",
    width: 3.836,
    height: 1.219,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-24"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2336",
    "data-name": "Rectangle 2336",
    width: 3.456,
    height: 1.076,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-25"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2337",
    "data-name": "Rectangle 2337",
    width: 4.048,
    height: 4.503,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-26"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2338",
    "data-name": "Rectangle 2338",
    width: 1.891,
    height: 3.455,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-27"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2339",
    "data-name": "Rectangle 2339",
    width: 9.441,
    height: 11.791,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-28"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2340",
    "data-name": "Rectangle 2340",
    width: 7.862,
    height: 1.729,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-29"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2341",
    "data-name": "Rectangle 2341",
    width: 0.963,
    height: 3.703,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-30"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2342",
    "data-name": "Rectangle 2342",
    width: 4.027,
    height: 5.105,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-31"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2343",
    "data-name": "Rectangle 2343",
    width: 3.57,
    height: 1.076,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Verif",
    transform: "translate(-0.125 0.3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_848",
    "data-name": "Groupe 848",
    transform: "translate(-0.131 0.2)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2276",
    "data-name": "Rectangle 2276",
    width: 118.014,
    height: 0.059,
    transform: "translate(0.137 79.05)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2277",
    "data-name": "Rectangle 2277",
    width: 8.12,
    height: 0.059,
    transform: "translate(81.55 81.227)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2278",
    "data-name": "Rectangle 2278",
    width: 4.569,
    height: 0.059,
    transform: "translate(94.651 81.059)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2279",
    "data-name": "Rectangle 2279",
    width: 6.062,
    height: 0.059,
    transform: "translate(52.456 81.197)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2280",
    "data-name": "Rectangle 2280",
    width: 4.14,
    height: 0.059,
    transform: "translate(58.754 82.036)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2281",
    "data-name": "Rectangle 2281",
    width: 12.506,
    height: 0.059,
    transform: "translate(21.777 80.602)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_847",
    "data-name": "Groupe 847"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_846",
    "data-name": "Groupe 846",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7586",
    "data-name": "Trac\\xE9 7586",
    d: "M85.131,75.157H39.554a1.349,1.349,0,0,1-1.347-1.347V9.744A1.349,1.349,0,0,1,39.554,8.4H85.131a1.349,1.349,0,0,1,1.347,1.347V73.809a1.349,1.349,0,0,1-1.347,1.347M39.554,8.456a1.29,1.29,0,0,0-1.288,1.288V73.809A1.29,1.29,0,0,0,39.554,75.1H85.131a1.29,1.29,0,0,0,1.288-1.288V9.744a1.29,1.29,0,0,0-1.288-1.288Z",
    transform: "translate(-29.052 -6.633)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7587",
    "data-name": "Trac\\xE9 7587",
    d: "M301.429,75.157H255.852a1.349,1.349,0,0,1-1.347-1.347V9.744A1.349,1.349,0,0,1,255.852,8.4h45.577a1.349,1.349,0,0,1,1.347,1.347V73.809a1.349,1.349,0,0,1-1.347,1.347m-45.577-66.7a1.29,1.29,0,0,0-1.288,1.288V73.809a1.29,1.29,0,0,0,1.288,1.288h45.577a1.29,1.29,0,0,0,1.288-1.288V9.744a1.29,1.29,0,0,0-1.288-1.288Z",
    transform: "translate(-194.298 -6.633)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2282",
    "data-name": "Rectangle 2282",
    width: 35.569,
    height: 30.579,
    transform: "translate(67.012 7.503)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2283",
    "data-name": "Rectangle 2283",
    width: 35.569,
    height: 30.579,
    transform: "translate(67.802 7.503)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2284",
    "data-name": "Rectangle 2284",
    width: 32.731,
    height: 27.709,
    transform: "translate(69.221 8.938)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2285",
    "data-name": "Rectangle 2285",
    width: 2.14,
    height: 27.709,
    transform: "translate(89.352 8.938)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2286",
    "data-name": "Rectangle 2286",
    width: 2.14,
    height: 27.709,
    transform: "translate(78.101 8.938)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2287",
    "data-name": "Rectangle 2287",
    width: 2.14,
    height: 29.687,
    transform: "translate(90.104 7.871)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2288",
    "data-name": "Rectangle 2288",
    width: 2.14,
    height: 29.687,
    transform: "translate(78.853 7.871)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2289",
    "data-name": "Rectangle 2289",
    width: 0.598,
    height: 27.709,
    transform: "translate(101.355 8.938)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7588",
    "data-name": "Trac\\xE9 7588",
    d: "M172.46,91.659s-4.328-7.461,1.677-13.4c0,0,1.567,1.021,1.543,2.394S174,82.374,174.357,83.52s1.917,2.27.892,3.218.165,1.791.1,2.952-2.885,1.97-2.885,1.97",
    transform: "translate(-130.465 -60.006)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7589",
    "data-name": "Trac\\xE9 7589",
    d: "M158.757,100.751s1.755-8.445-5.817-12.188a3.391,3.391,0,0,0-.709,2.759c.456,1.3,2.135,1.1,2.159,2.3s-1.1,2.759.168,3.335.408,1.752.84,2.831,3.359.96,3.359.96",
    transform: "translate(-116.082 -67.878)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7590",
    "data-name": "Trac\\xE9 7590",
    d: "M163.892,131.117s.076,7.289,2.99,7.289,2.99-7.289,2.99-7.289Z",
    transform: "translate(-125.072 -100.388)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7591",
    "data-name": "Trac\\xE9 7591",
    d: "M89.691,150.38s.162,2.743,6.388,2.743,6.388-2.743,6.388-2.743Z",
    transform: "translate(-68.384 -115.104)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7592",
    "data-name": "Trac\\xE9 7592",
    d: "M354.667,227.362H351.38a.74.74,0,0,1-.74-.74v-5.436a.74.74,0,0,1,.74-.74h3.287a.74.74,0,0,1,.74.74v5.436a.74.74,0,0,1-.74.74",
    transform: "translate(-267.742 -168.632)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7593",
    "data-name": "Trac\\xE9 7593",
    d: "M395.845,234.684h-2.212a.5.5,0,0,1-.5-.5v-3.658a.5.5,0,0,1,.5-.5h2.212a.5.5,0,0,1,.5.5v3.658a.5.5,0,0,1-.5.5",
    transform: "translate(-300.207 -175.955)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7594",
    "data-name": "Trac\\xE9 7594",
    d: "M396.176,228.637H393.3a.167.167,0,0,1-.167-.167v-.19a.168.168,0,0,1,.167-.167h2.874a.167.167,0,0,1,.167.167v.19a.167.167,0,0,1-.167.167",
    transform: "translate(-300.207 -174.49)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7595",
    "data-name": "Trac\\xE9 7595",
    d: "M318.423,233.445s.118,3.848,4.624,3.848,4.624-3.848,4.624-3.848Z",
    transform: "translate(-243.129 -178.564)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2290",
    "data-name": "Rectangle 2290",
    width: 6.819,
    height: 1.344,
    transform: "translate(64.087 48.456)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2291",
    "data-name": "Rectangle 2291",
    width: 33.901,
    height: 1.344,
    transform: "translate(70.905 48.456)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2292",
    "data-name": "Rectangle 2292",
    width: 6.819,
    height: 1.344,
    transform: "translate(64.087 58.729)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2293",
    "data-name": "Rectangle 2293",
    width: 33.901,
    height: 1.344,
    transform: "translate(70.905 58.729)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2294",
    "data-name": "Rectangle 2294",
    width: 1.259,
    height: 29.25,
    transform: "translate(65.287 49.8)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2295",
    "data-name": "Rectangle 2295",
    width: 1.259,
    height: 29.25,
    transform: "translate(70.905 49.8)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2296",
    "data-name": "Rectangle 2296",
    width: 1.259,
    height: 29.25,
    transform: "translate(99.187 49.8)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2297",
    "data-name": "Rectangle 2297",
    width: 1.259,
    height: 29.25,
    transform: "translate(103.547 49.8)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2298",
    "data-name": "Rectangle 2298",
    width: 6.448,
    height: 37.549,
    transform: "translate(14.859 39.729)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2299",
    "data-name": "Rectangle 2299",
    width: 31.797,
    height: 1.772,
    transform: "translate(16.097 77.278)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2300",
    "data-name": "Rectangle 2300",
    width: 27.825,
    height: 37.549,
    transform: "translate(21.307 39.729)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2301",
    "data-name": "Rectangle 2301",
    width: 22.756,
    height: 9.171,
    transform: "translate(23.842 53.918)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2302",
    "data-name": "Rectangle 2302",
    width: 22.756,
    height: 9.171,
    transform: "translate(23.842 64.762)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7596",
    "data-name": "Trac\\xE9 7596",
    d: "M140.887,229.554h-5.109a.629.629,0,0,1,0-1.258h5.109a.629.629,0,0,1,0,1.258",
    transform: "translate(-103.113 -174.63)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2303",
    "data-name": "Rectangle 2303",
    width: 22.756,
    height: 9.171,
    transform: "translate(23.842 43.075)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7597",
    "data-name": "Trac\\xE9 7597",
    d: "M140.887,183.612h-5.109a.629.629,0,0,1,0-1.258h5.109a.629.629,0,0,1,0,1.258",
    transform: "translate(-103.113 -139.532)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7598",
    "data-name": "Trac\\xE9 7598",
    d: "M140.887,275.5h-5.109a.629.629,0,0,1,0-1.258h5.109a.629.629,0,0,1,0,1.258",
    transform: "translate(-103.113 -209.729)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2304",
    "data-name": "Rectangle 2304",
    width: 28.685,
    height: 1.711,
    transform: "translate(21.307 38.018)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2305",
    "data-name": "Rectangle 2305",
    width: 7.349,
    height: 1.711,
    transform: "translate(13.958 38.018)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2306",
    "data-name": "Rectangle 2306",
    width: 10.433,
    height: 11.456,
    transform: "translate(18.06 8.938)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2307",
    "data-name": "Rectangle 2307",
    width: 10.777,
    height: 11.456,
    transform: "translate(18.847 8.938)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2308",
    "data-name": "Rectangle 2308",
    width: 8.971,
    height: 9.65,
    transform: "translate(19.75 9.841)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2309",
    "data-name": "Rectangle 2309",
    width: 4.622,
    height: 4.972,
    transform: "translate(21.924 12.18)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2310",
    "data-name": "Rectangle 2310",
    width: 7.912,
    height: 8.498,
    transform: "translate(31.581 5.555)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2311",
    "data-name": "Rectangle 2311",
    width: 7.994,
    height: 8.498,
    transform: "translate(32.338 5.555)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2312",
    "data-name": "Rectangle 2312",
    width: 6.655,
    height: 7.159,
    transform: "translate(33.008 6.225)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7599",
    "data-name": "Trac\\xE9 7599",
    d: "M147.471,34.8l-1.82,3.152h3.64Z",
    transform: "translate(-111.136 -26.801)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7600",
    "data-name": "Trac\\xE9 7600",
    d: "M147.637,361.033c0,1.476-20.489,2.673-45.763,2.673s-45.763-1.2-45.763-2.673,20.489-2.673,45.763-2.673,45.763,1.2,45.763,2.673",
    transform: "translate(-42.73 -273.995)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7601",
    "data-name": "Trac\\xE9 7601",
    d: "M337.7,109.983H314.542a2.218,2.218,0,0,1-2.211-2.211v-6.3a2.218,2.218,0,0,1,2.211-2.211H337.7a2.218,2.218,0,0,1,2.211,2.211v6.3a2.218,2.218,0,0,1-2.211,2.211",
    transform: "translate(-238.475 -76.052)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7602",
    "data-name": "Trac\\xE9 7602",
    d: "M340.544,108.121H322.46a.389.389,0,0,1-.388-.388v-.423a.389.389,0,0,1,.388-.388h18.084a.389.389,0,0,1,.388.388v.423a.389.389,0,0,1-.388.388",
    transform: "translate(-245.917 -81.904)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7603",
    "data-name": "Trac\\xE9 7603",
    d: "M334.816,120.364H322.46a.389.389,0,0,1-.388-.388v-.423a.389.389,0,0,1,.388-.388h12.356a.389.389,0,0,1,.388.388v.423a.389.389,0,0,1-.388.388",
    transform: "translate(-245.917 -91.257)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7604",
    "data-name": "Trac\\xE9 7604",
    d: "M331.5,132.606H322.46a.389.389,0,0,1-.388-.388V131.8a.389.389,0,0,1,.388-.388H331.5a.389.389,0,0,1,.388.388v.423a.389.389,0,0,1-.388.388",
    transform: "translate(-245.917 -100.609)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7605",
    "data-name": "Trac\\xE9 7605",
    d: "M378.993,132.606h-9.042a.389.389,0,0,1-.388-.388V131.8a.389.389,0,0,1,.388-.388h9.042a.389.389,0,0,1,.388.388v.423a.389.389,0,0,1-.388.388",
    transform: "translate(-282.199 -100.609)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_761",
    "data-name": "Groupe 761",
    transform: "translate(76.155 25.019)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_760",
    "data-name": "Groupe 760"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_759",
    "data-name": "Groupe 759",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7606",
    "data-name": "Trac\\xE9 7606",
    d: "M340.544,108.121H322.46a.389.389,0,0,1-.388-.388v-.423a.389.389,0,0,1,.388-.388h18.084a.389.389,0,0,1,.388.388v.423a.389.389,0,0,1-.388.388",
    transform: "translate(-322.072 -106.922)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7607",
    "data-name": "Trac\\xE9 7607",
    d: "M334.816,120.364H322.46a.389.389,0,0,1-.388-.388v-.423a.389.389,0,0,1,.388-.388h12.356a.389.389,0,0,1,.388.388v.423a.389.389,0,0,1-.388.388",
    transform: "translate(-322.072 -116.276)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7608",
    "data-name": "Trac\\xE9 7608",
    d: "M331.5,132.606H322.46a.389.389,0,0,1-.388-.388V131.8a.389.389,0,0,1,.388-.388H331.5a.389.389,0,0,1,.388.388v.423a.389.389,0,0,1-.388.388",
    transform: "translate(-322.072 -125.628)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7609",
    "data-name": "Trac\\xE9 7609",
    d: "M378.993,132.606h-9.042a.389.389,0,0,1-.388-.388V131.8a.389.389,0,0,1,.388-.388h9.042a.389.389,0,0,1,.388.388v.423a.389.389,0,0,1-.388.388",
    transform: "translate(-358.354 -125.628)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7610",
    "data-name": "Trac\\xE9 7610",
    d: "M245.652,104.394H219.369a3.251,3.251,0,0,1-3.242-3.242V91.917a3.251,3.251,0,0,1,3.242-3.242h26.284a3.251,3.251,0,0,1,3.242,3.242v9.235a3.251,3.251,0,0,1-3.242,3.242",
    transform: "translate(-164.978 -67.963)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7611",
    "data-name": "Trac\\xE9 7611",
    d: "M257.493,101.664H230.979a.571.571,0,0,1-.569-.569v-.62a.571.571,0,0,1,.569-.569h26.514a.57.57,0,0,1,.569.569v.62a.57.57,0,0,1-.569.569",
    transform: "translate(-175.89 -76.544)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7612",
    "data-name": "Trac\\xE9 7612",
    d: "M249.095,119.614H230.979a.57.57,0,0,1-.569-.569v-.621a.57.57,0,0,1,.569-.569h18.116a.57.57,0,0,1,.569.569v.621a.57.57,0,0,1-.569.569",
    transform: "translate(-175.89 -90.257)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7613",
    "data-name": "Trac\\xE9 7613",
    d: "M244.236,137.564H230.979a.571.571,0,0,1-.569-.569v-.621a.571.571,0,0,1,.569-.569h13.257a.571.571,0,0,1,.569.569V137a.571.571,0,0,1-.569.569",
    transform: "translate(-175.89 -103.97)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7614",
    "data-name": "Trac\\xE9 7614",
    d: "M311.656,137.564H300.609a.57.57,0,0,1-.569-.569v-.621a.57.57,0,0,1,.569-.569h11.047a.57.57,0,0,1,.569.569V137a.57.57,0,0,1-.569.569",
    transform: "translate(-229.085 -103.97)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_764",
    "data-name": "Groupe 764",
    transform: "translate(54.52 23.362)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_763",
    "data-name": "Groupe 763"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_762",
    "data-name": "Groupe 762",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7615",
    "data-name": "Trac\\xE9 7615",
    d: "M257.493,101.664H230.979a.571.571,0,0,1-.569-.569v-.62a.571.571,0,0,1,.569-.569h26.514a.57.57,0,0,1,.569.569v.62a.57.57,0,0,1-.569.569",
    transform: "translate(-230.41 -99.906)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7616",
    "data-name": "Trac\\xE9 7616",
    d: "M249.095,119.614H230.979a.57.57,0,0,1-.569-.569v-.621a.57.57,0,0,1,.569-.569h18.116a.57.57,0,0,1,.569.569v.621a.57.57,0,0,1-.569.569",
    transform: "translate(-230.41 -113.619)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7617",
    "data-name": "Trac\\xE9 7617",
    d: "M244.236,137.564H230.979a.571.571,0,0,1-.569-.569v-.621a.571.571,0,0,1,.569-.569h13.257a.571.571,0,0,1,.569.569V137a.571.571,0,0,1-.569.569",
    transform: "translate(-230.41 -127.333)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7618",
    "data-name": "Trac\\xE9 7618",
    d: "M311.656,137.564H300.609a.57.57,0,0,1-.569-.569v-.621a.57.57,0,0,1,.569-.569h11.047a.57.57,0,0,1,.569.569V137a.57.57,0,0,1-.569.569",
    transform: "translate(-283.605 -127.333)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7619",
    "data-name": "Trac\\xE9 7619",
    d: "M226.109,189.337H213.45a1.52,1.52,0,0,1-1.515-1.515V168.86a1.52,1.52,0,0,1,1.515-1.515h12.659a1.52,1.52,0,0,1,1.515,1.515v18.961a1.52,1.52,0,0,1-1.515,1.515",
    transform: "translate(-161.775 -128.065)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_767",
    "data-name": "Groupe 767",
    transform: "translate(50.16 39.28)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_766",
    "data-name": "Groupe 766"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_765",
    "data-name": "Groupe 765",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7620",
    "data-name": "Trac\\xE9 7620",
    d: "M226.109,189.337H213.45a1.52,1.52,0,0,1-1.515-1.515V168.86a1.52,1.52,0,0,1,1.515-1.515h12.659a1.52,1.52,0,0,1,1.515,1.515v18.961a1.52,1.52,0,0,1-1.515,1.515",
    transform: "translate(-211.935 -167.345)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7621",
    "data-name": "Trac\\xE9 7621",
    d: "M231.409,178.035h-11.5a.28.28,0,0,1-.28-.279v-.415a.28.28,0,0,1,.28-.279h11.5a.28.28,0,0,1,.279.279v.415a.28.28,0,0,1-.279.279",
    transform: "translate(-167.655 -135.488)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7622",
    "data-name": "Trac\\xE9 7622",
    d: "M227.747,187.98h-7.836a.28.28,0,0,1-.28-.279v-.415a.28.28,0,0,1,.28-.279h7.836a.28.28,0,0,1,.279.279v.415a.28.28,0,0,1-.279.279",
    transform: "translate(-167.655 -143.086)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7623",
    "data-name": "Trac\\xE9 7623",
    d: "M231.409,197.925h-11.5a.28.28,0,0,1-.28-.279v-.415a.28.28,0,0,1,.28-.279h11.5a.28.28,0,0,1,.279.279v.415a.28.28,0,0,1-.279.279",
    transform: "translate(-167.655 -150.683)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7624",
    "data-name": "Trac\\xE9 7624",
    d: "M224.183,207.87h-4.271a.28.28,0,0,1-.279-.279v-.415a.28.28,0,0,1,.279-.279h4.271a.28.28,0,0,1,.279.279v.415a.28.28,0,0,1-.279.279",
    transform: "translate(-167.655 -158.281)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7625",
    "data-name": "Trac\\xE9 7625",
    d: "M249.518,207.87h-4.271a.28.28,0,0,1-.279-.279v-.415a.28.28,0,0,1,.279-.279h4.271a.28.28,0,0,1,.279.279v.415a.28.28,0,0,1-.279.279",
    transform: "translate(-187.011 -158.281)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7626",
    "data-name": "Trac\\xE9 7626",
    d: "M231.409,217.815h-11.5a.28.28,0,0,1-.28-.279v-.415a.28.28,0,0,1,.28-.279h11.5a.28.28,0,0,1,.279.279v.415a.28.28,0,0,1-.279.279",
    transform: "translate(-167.655 -165.879)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7627",
    "data-name": "Trac\\xE9 7627",
    d: "M231.409,227.761h-11.5a.28.28,0,0,1-.28-.279v-.415a.28.28,0,0,1,.28-.279h11.5a.28.28,0,0,1,.279.279v.415a.28.28,0,0,1-.279.279",
    transform: "translate(-167.655 -173.477)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7628",
    "data-name": "Trac\\xE9 7628",
    d: "M229.369,237.706H219.91a.28.28,0,0,1-.279-.279v-.415a.28.28,0,0,1,.279-.279h9.459a.28.28,0,0,1,.279.279v.415a.28.28,0,0,1-.279.279",
    transform: "translate(-167.655 -181.075)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7629",
    "data-name": "Trac\\xE9 7629",
    d: "M224.322,247.651h-4.411a.28.28,0,0,1-.28-.279v-.415a.28.28,0,0,1,.28-.279h4.411a.28.28,0,0,1,.28.279v.415a.28.28,0,0,1-.28.279",
    transform: "translate(-167.655 -188.673)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7630",
    "data-name": "Trac\\xE9 7630",
    d: "M229.67,166.778H212.114l7.754,6.177,11.9,4.478V168.88a2.108,2.108,0,0,0-2.1-2.1",
    transform: "translate(-161.912 -127.632)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_770",
    "data-name": "Groupe 770",
    transform: "translate(50.202 39.146)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_769",
    "data-name": "Groupe 769"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_768",
    "data-name": "Groupe 768",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7631",
    "data-name": "Trac\\xE9 7631",
    d: "M229.67,166.778H212.114l7.754,6.177,11.9,4.478V168.88a2.108,2.108,0,0,0-2.1-2.1",
    transform: "translate(-212.114 -166.778)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7632",
    "data-name": "Trac\\xE9 7632",
    d: "M240.535,181.6H227.687a.35.35,0,0,1-.349-.349V180.6a.35.35,0,0,1,.349-.349h12.848a.35.35,0,0,1,.349.349v.653a.35.35,0,0,1-.349.349",
    transform: "translate(-173.543 -137.926)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7633",
    "data-name": "Trac\\xE9 7633",
    d: "M309.77,192.1V179.751a1.719,1.719,0,0,1,1.714-1.714h21.444a1.719,1.719,0,0,1,1.714,1.714V192.1a1.719,1.719,0,0,1-1.714,1.714H311.484a1.719,1.719,0,0,1-1.714-1.714",
    transform: "translate(-236.518 -136.234)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7634",
    "data-name": "Trac\\xE9 7634",
    d: "M326.359,175.509V163.162a1.719,1.719,0,0,1,1.714-1.714h21.444a1.719,1.719,0,0,1,1.714,1.714v12.347a1.719,1.719,0,0,1-1.714,1.714H328.073a1.719,1.719,0,0,1-1.714-1.714",
    transform: "translate(-249.192 -123.56)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_773",
    "data-name": "Groupe 773",
    transform: "translate(77.167 37.888)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_772",
    "data-name": "Groupe 772"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_771",
    "data-name": "Groupe 771",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7635",
    "data-name": "Trac\\xE9 7635",
    d: "M326.359,175.509V163.162a1.719,1.719,0,0,1,1.714-1.714h21.444a1.719,1.719,0,0,1,1.714,1.714v12.347a1.719,1.719,0,0,1-1.714,1.714H328.073a1.719,1.719,0,0,1-1.714-1.714",
    transform: "translate(-326.359 -161.448)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7636",
    "data-name": "Trac\\xE9 7636",
    d: "M386.362,176.034v-7.6a.766.766,0,0,1,.764-.764h7.006a.766.766,0,0,1,.764.764v7.6a.766.766,0,0,1-.764.764h-7.006a.766.766,0,0,1-.764-.764",
    transform: "translate(-295.033 -128.314)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_776",
    "data-name": "Groupe 776",
    transform: "translate(91.329 39.357)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_775",
    "data-name": "Groupe 775"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_774",
    "data-name": "Groupe 774",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7637",
    "data-name": "Trac\\xE9 7637",
    d: "M386.362,176.034v-7.6a.766.766,0,0,1,.764-.764h7.006a.766.766,0,0,1,.764.764v7.6a.766.766,0,0,1-.764.764h-7.006a.766.766,0,0,1-.764-.764",
    transform: "translate(-386.362 -167.671)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7638",
    "data-name": "Trac\\xE9 7638",
    d: "M353,197.931v-5.825a.587.587,0,0,1,.585-.585h5.37a.587.587,0,0,1,.585.585v5.825a.587.587,0,0,1-.585.585h-5.37a.587.587,0,0,1-.585-.585",
    transform: "translate(-269.544 -146.534)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_779",
    "data-name": "Groupe 779",
    transform: "translate(83.455 44.986)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_778",
    "data-name": "Groupe 778"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_777",
    "data-name": "Groupe 777",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7639",
    "data-name": "Trac\\xE9 7639",
    d: "M353,197.931v-5.825a.587.587,0,0,1,.585-.585h5.37a.587.587,0,0,1,.585.585v5.825a.587.587,0,0,1-.585.585h-5.37a.587.587,0,0,1-.585-.585",
    transform: "translate(-352.999 -191.52)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7640",
    "data-name": "Trac\\xE9 7640",
    d: "M107.963,46.392V43.244A1.747,1.747,0,0,1,109.7,41.5h57.623a1.747,1.747,0,0,1,1.741,1.741v3.147a1.747,1.747,0,0,1-1.741,1.741H109.7a1.747,1.747,0,0,1-1.741-1.741",
    transform: "translate(-82.343 -31.925)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_782",
    "data-name": "Groupe 782",
    transform: "translate(25.62 9.578)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_781",
    "data-name": "Groupe 781"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_780",
    "data-name": "Groupe 780",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7641",
    "data-name": "Trac\\xE9 7641",
    d: "M107.963,46.392V43.244A1.747,1.747,0,0,1,109.7,41.5h57.623a1.747,1.747,0,0,1,1.741,1.741v3.147a1.747,1.747,0,0,1-1.741,1.741H109.7a1.747,1.747,0,0,1-1.741-1.741",
    transform: "translate(-107.963 -41.503)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2321",
    "data-name": "Rectangle 2321",
    width: 16.581,
    height: 2.283,
    transform: "translate(59.242 15.032)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_785",
    "data-name": "Groupe 785",
    transform: "translate(59.242 15.032)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_784",
    "data-name": "Groupe 784"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_783",
    "data-name": "Groupe 783",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2322",
    "data-name": "Rectangle 2322",
    width: 16.581,
    height: 2.283,
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7642",
    "data-name": "Trac\\xE9 7642",
    d: "M133.14,4.889V1.741A1.747,1.747,0,0,1,134.881,0H192.5a1.746,1.746,0,0,1,1.741,1.741V4.889A1.746,1.746,0,0,1,192.5,6.63H134.881a1.747,1.747,0,0,1-1.741-1.741",
    transform: "translate(-101.578 -0.218)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7643",
    "data-name": "Trac\\xE9 7643",
    d: "M115.562,143.961c-.207.463-.437.98-.638,1.479s-.407,1.01-.588,1.519a21.387,21.387,0,0,0-.895,3.053l-.069.376-.024.143c-.007.039-.008.092-.014.138a5.136,5.136,0,0,0,.015.69c.044.5.124,1.031.225,1.566.2,1.069.452,2.172.7,3.256l-1.211.479a21.89,21.89,0,0,1-1.439-3.209,13.315,13.315,0,0,1-.5-1.761,6.3,6.3,0,0,1-.133-1.005c0-.1-.007-.185,0-.288s.008-.213.017-.28l.046-.467a15.461,15.461,0,0,1,.324-1.806c.133-.59.3-1.163.484-1.729s.384-1.123.607-1.67c.111-.274.226-.546.346-.817s.241-.532.386-.822Z",
    transform: "translate(-84.657 -109.316)",
    fill: "#e4897b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7644",
    "data-name": "Trac\\xE9 7644",
    d: "M120.32,198.135l.921.9-2.008.934a2.018,2.018,0,0,1-.151-1.62Z",
    transform: "translate(-90.747 -151.588)",
    fill: "#e4897b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7645",
    "data-name": "Trac\\xE9 7645",
    d: "M122.855,203.28l-1.7.694-1.054-1.1,2.008-.934Z",
    transform: "translate(-91.62 -154.497)",
    fill: "#e4897b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_788",
    "data-name": "Groupe 788",
    transform: "translate(50.501 13.926)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_787",
    "data-name": "Groupe 787"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_786",
    "data-name": "Groupe 786",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7646",
    "data-name": "Trac\\xE9 7646",
    d: "M228.493,93.818a17,17,0,1,1,18.781-15,17,17,0,0,1-18.781,15",
    transform: "translate(-213.382 -59.927)",
    fill: "#fafafa"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_791",
    "data-name": "Groupe 791",
    transform: "translate(50.589 14.811)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_790",
    "data-name": "Groupe 790"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_789",
    "data-name": "Groupe 789",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7647",
    "data-name": "Trac\\xE9 7647",
    d: "M241.142,66.4,215.3,87.053c-.111-.233-.215-.47-.316-.708a16.766,16.766,0,0,1-1.228-4.833v0l22.323-17.837a16.865,16.865,0,0,1,5.066,2.729",
    transform: "translate(-213.754 -63.674)",
    fill: "#fafafa"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_794",
    "data-name": "Groupe 794",
    transform: "translate(53.795 19.776)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_793",
    "data-name": "Groupe 793"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_792",
    "data-name": "Groupe 792",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7648",
    "data-name": "Trac\\xE9 7648",
    d: "M257.483,91.521l-24.3,19.413a16.982,16.982,0,0,1-5.847-5.024l26.533-21.2a17,17,0,0,1,3.611,6.811",
    transform: "translate(-227.338 -84.71)",
    fill: "#fafafa"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_800",
    "data-name": "Groupe 800",
    transform: "translate(48.155 11.83)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_799",
    "data-name": "Groupe 799"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_798",
    "data-name": "Groupe 798",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7649",
    "data-name": "Trac\\xE9 7649",
    d: "M203.663,63.657l-.224-.076a20.723,20.723,0,0,1,1.458-3.317l.207.114a20.512,20.512,0,0,0-1.441,3.279m2.866-5.51-.19-.14a20.474,20.474,0,0,1,7.4-6.185l.1.212a20.233,20.233,0,0,0-7.319,6.114m25.868-5.79a20.047,20.047,0,0,0-2.385-1.091l.084-.221a20.315,20.315,0,0,1,2.413,1.1Z",
    transform: "translate(-203.439 -51.045)",
    fill: "#f60"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_797",
    "data-name": "Groupe 797",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_796",
    "data-name": "Groupe 796"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_795",
    "data-name": "Groupe 795",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7650",
    "data-name": "Trac\\xE9 7650",
    d: "M203.663,63.657l-.224-.076a20.723,20.723,0,0,1,1.458-3.317l.207.114a20.512,20.512,0,0,0-1.441,3.279m2.866-5.51-.19-.14a20.474,20.474,0,0,1,7.4-6.185l.1.212a20.233,20.233,0,0,0-7.319,6.114m25.868-5.79a20.047,20.047,0,0,0-2.385-1.091l.084-.221a20.315,20.315,0,0,1,2.413,1.1Z",
    transform: "translate(-203.439 -51.045)",
    fill: "#f60"
  }))))))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7651",
    "data-name": "Trac\\xE9 7651",
    d: "M166.4,59.807a19.6,19.6,0,0,0-36.03,15.277c-1.577.553-3.134,1.147-4.683,1.757q-3.349,1.327-6.637,2.776c-2.19.971-4.371,1.96-6.53,2.994-1.085.506-2.154,1.043-3.232,1.563a4.663,4.663,0,0,0-1.5,1.025,4.412,4.412,0,0,0-.607.8,4.075,4.075,0,0,0-.462,1.092,3,3,0,0,0,1.73,3.5,4.081,4.081,0,0,0,1.148.3,4.411,4.411,0,0,0,1,0,4.661,4.661,0,0,0,1.723-.564c1.068-.54,2.145-1.063,3.206-1.616,2.133-1.085,4.245-2.215,6.347-3.363s4.18-2.346,6.24-3.581c1.426-.858,2.844-1.733,4.243-2.649A19.6,19.6,0,0,0,166.4,59.807m-10.73,22.547A15.468,15.468,0,1,1,162.7,61.637a15.467,15.467,0,0,1-7.022,20.717",
    transform: "translate(-81.328 -37.559)",
    fill: "#f60"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_803",
    "data-name": "Groupe 803",
    transform: "translate(25.306 11.318)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_802",
    "data-name": "Groupe 802"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_801",
    "data-name": "Groupe 801",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7652",
    "data-name": "Trac\\xE9 7652",
    d: "M166.4,59.807a19.6,19.6,0,0,0-36.03,15.277c-1.577.553-3.134,1.147-4.683,1.757q-3.349,1.327-6.637,2.776c-2.19.971-4.371,1.96-6.53,2.994-1.085.506-2.154,1.043-3.232,1.563a4.663,4.663,0,0,0-1.5,1.025,4.412,4.412,0,0,0-.607.8,4.075,4.075,0,0,0-.462,1.092,3,3,0,0,0,1.73,3.5,4.081,4.081,0,0,0,1.148.3,4.411,4.411,0,0,0,1,0,4.661,4.661,0,0,0,1.723-.564c1.068-.54,2.145-1.063,3.206-1.616,2.133-1.085,4.245-2.215,6.347-3.363s4.18-2.346,6.24-3.581c1.426-.858,2.844-1.733,4.243-2.649A19.6,19.6,0,0,0,166.4,59.807m-10.73,22.547A15.468,15.468,0,1,1,162.7,61.637a15.467,15.467,0,0,1-7.022,20.717",
    transform: "translate(-106.634 -48.878)",
    fill: "#f60"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7653",
    "data-name": "Trac\\xE9 7653",
    d: "M158.022,111.176c0,.14.074.253.165.253s.166-.113.166-.253-.074-.253-.165-.253-.166.113-.166.253",
    transform: "translate(-120.587 -84.96)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7654",
    "data-name": "Trac\\xE9 7654",
    d: "M158.276,113.068a5.005,5.005,0,0,0,.667,1.2.806.806,0,0,1-.668.125Z",
    transform: "translate(-120.78 -86.599)",
    fill: "#de5753"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7655",
    "data-name": "Trac\\xE9 7655",
    d: "M155.659,107.693a.082.082,0,0,1-.048-.149.814.814,0,0,1,.739-.126.082.082,0,0,1-.059.153.651.651,0,0,0-.584.107.083.083,0,0,1-.048.015",
    transform: "translate(-118.719 -82.253)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7656",
    "data-name": "Trac\\xE9 7656",
    d: "M136.532,116.462c.249,1.268.5,3.593-.391,4.439,0,0,.347,1.287,2.7,1.287,2.592,0,1.239-1.287,1.239-1.287-1.415-.338-1.378-1.387-1.132-2.373Z",
    transform: "translate(-103.871 -89.192)",
    fill: "#e4897b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7657",
    "data-name": "Trac\\xE9 7657",
    d: "M131.029,132.153c.28-.437-.193-1.495-.193-1.495s4.175-1.051,5.881.561c.354.334-.039.824-.039.824Z",
    transform: "translate(-99.818 -99.78)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_806",
    "data-name": "Groupe 806",
    transform: "translate(31.018 30.541)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_805",
    "data-name": "Groupe 805"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_804",
    "data-name": "Groupe 804",
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7658",
    "data-name": "Trac\\xE9 7658",
    d: "M131.029,132.153c.28-.437-.193-1.495-.193-1.495s4.175-1.051,5.881.561c.354.334-.039.824-.039.824Z",
    transform: "translate(-130.836 -130.322)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7659",
    "data-name": "Trac\\xE9 7659",
    d: "M100.187,340.274c-.22,0-.571-.367-.675-.5a.041.041,0,0,1,0-.045.046.046,0,0,1,.039-.021c.025,0,.6.052.761.258a.19.19,0,0,1,.039.156.158.158,0,0,1-.161.156m-.546-.477c.173.2.448.421.567.393.011,0,.046-.011.06-.087a.11.11,0,0,0-.024-.091,1.116,1.116,0,0,0-.6-.215",
    transform: "translate(-75.881 -259.743)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7660",
    "data-name": "Trac\\xE9 7660",
    d: "M99.666,338.62a.707.707,0,0,1-.128-.01.042.042,0,0,1-.031-.028.041.041,0,0,1,.009-.041c.015-.016.364-.376.624-.376h0a.225.225,0,0,1,.169.07.134.134,0,0,1,.033.166c-.078.143-.44.218-.676.218m-.029-.082c.223.009.577-.074.633-.176,0-.009.017-.031-.02-.07a.143.143,0,0,0-.109-.044h0a1,1,0,0,0-.5.29",
    transform: "translate(-75.882 -258.567)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7661",
    "data-name": "Trac\\xE9 7661",
    d: "M166.56,363.46a3.05,3.05,0,0,1-.532-.049.041.041,0,0,1-.013-.076c.026-.015.631-.361.92-.282a.2.2,0,0,1,.13.1.155.155,0,0,1,0,.179c-.072.1-.287.131-.51.131m-.4-.11c.322.046.761.043.842-.069.01-.015.021-.04-.008-.091a.123.123,0,0,0-.081-.057,1.465,1.465,0,0,0-.753.217",
    transform: "translate(-126.678 -277.572)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7662",
    "data-name": "Trac\\xE9 7662",
    d: "M166.035,362.068a.04.04,0,0,1-.024-.008.041.041,0,0,1-.017-.037,1.172,1.172,0,0,1,.269-.668.3.3,0,0,1,.228-.07c.113.011.145.069.153.115.032.2-.383.571-.592.665a.043.043,0,0,1-.017,0m.423-.7a.218.218,0,0,0-.143.054.962.962,0,0,0-.229.534c.214-.128.5-.423.476-.541,0-.009-.006-.039-.08-.046h-.025",
    transform: "translate(-126.678 -276.229)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7663",
    "data-name": "Trac\\xE9 7663",
    d: "M158.091,351.439h1.734l.173-4.015h-1.734Z",
    transform: "translate(-120.64 -265.641)",
    fill: "#e4897b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7664",
    "data-name": "Trac\\xE9 7664",
    d: "M92.635,326.481l1.45.95,3.2-2.7-1.45-.95Z",
    transform: "translate(-70.633 -247.576)",
    fill: "#e4897b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7665",
    "data-name": "Trac\\xE9 7665",
    d: "M89.974,334.766l-1.507-1.235a.151.151,0,0,0-.189,0l-1.242.975a.255.255,0,0,0,0,.4c.533.422.814.6,1.477,1.143.408.334,1.422,1.352,1.985,1.814s1.093-.035.9-.274a5.823,5.823,0,0,1-1.278-2.56.42.42,0,0,0-.15-.261",
    transform: "translate(-66.283 -255.001)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7666",
    "data-name": "Trac\\xE9 7666",
    d: "M157.653,363.585H155.76a.151.151,0,0,0-.148.118l-.342,1.541a.252.252,0,0,0,.249.308c.683-.012,1.67-.051,2.529-.051,1,0,1.871.055,3.048.055.712,0,.909-.72.612-.785a10.451,10.451,0,0,1-3.636-1.051.8.8,0,0,0-.418-.135",
    transform: "translate(-118.48 -277.987)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7667",
    "data-name": "Trac\\xE9 7667",
    d: "M114.052,136.831c-1.5.72-2.351,5.452-2.351,5.452l3.675,1.467a27.442,27.442,0,0,0,1.3-4.049c.5-2.19-1.086-3.606-2.624-2.87",
    transform: "translate(-85.199 -104.603)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7668",
    "data-name": "Trac\\xE9 7668",
    d: "M125.046,148.129a7.708,7.708,0,0,0-1.506,3.9l.88.352a27.545,27.545,0,0,0,1.275-3.93c-.078-.5-.271-.7-.649-.319",
    transform: "translate(-94.244 -113.232)",
    fill: "#203048"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7669",
    "data-name": "Trac\\xE9 7669",
    d: "M132.7,135.564s1.845,2.085.1,14.987H123.53c-.064-1.423.831-8.368-.542-15.076a24.224,24.224,0,0,1,3.1-.392,34.025,34.025,0,0,1,3.942,0,17.4,17.4,0,0,1,2.667.481",
    transform: "translate(-93.822 -103.374)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7670",
    "data-name": "Trac\\xE9 7670",
    d: "M161.434,149.808l-1.562-2.693a13.769,13.769,0,0,0-.367,3.841c.042.925.891,4.351,1.648,4.852a54.479,54.479,0,0,0,.281-6",
    transform: "translate(-121.707 -112.61)",
    fill: "#203048"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7671",
    "data-name": "Trac\\xE9 7671",
    d: "M160.278,145.113c.231,1.148.475,2.322.726,3.475s.513,2.308.818,3.425c.079.275.152.557.239.823l.063.2.031.1-.011-.012c-.018-.021-.037-.023-.023,0a.807.807,0,0,0,.36.223,4.285,4.285,0,0,0,.687.193,18.592,18.592,0,0,0,3.375.22l.224,1.282c-.317.1-.613.175-.923.247s-.618.135-.933.183a10.06,10.06,0,0,1-1.966.132,5.411,5.411,0,0,1-1.086-.141,3.169,3.169,0,0,1-1.245-.578,2.262,2.262,0,0,1-.583-.7c-.039-.07-.072-.151-.1-.219l-.044-.112-.087-.223c-.121-.3-.22-.594-.328-.891-.4-1.186-.731-2.37-1.025-3.56s-.543-2.376-.754-3.6Z",
    transform: "translate(-120.335 -111.081)",
    fill: "#e4897b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7672",
    "data-name": "Trac\\xE9 7672",
    d: "M154.076,138.233c-.489,1.584,1.492,6.306,1.492,6.306l3.945-.992a14.3,14.3,0,0,0-1.05-4.4c-1.356-2.937-3.8-2.815-4.387-.913",
    transform: "translate(-117.513 -104.778)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7673",
    "data-name": "Trac\\xE9 7673",
    d: "M191.438,181.607l1.964-.048-.944,2.042s-.8.106-1.455-.973l-.692-.824.8-.16a1.938,1.938,0,0,1,.332-.037",
    transform: "translate(-145.254 -138.924)",
    fill: "#e4897b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7674",
    "data-name": "Trac\\xE9 7674",
    d: "M201.592,181.939l-1.124,1.693-1.06-.03.944-2.042Z",
    transform: "translate(-152.205 -138.924)",
    fill: "#e4897b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7675",
    "data-name": "Trac\\xE9 7675",
    d: "M160.266,347.428l-.089,2.07h-1.735l.089-2.07Z",
    transform: "translate(-120.908 -265.644)",
    fill: "#ce6f64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7676",
    "data-name": "Trac\\xE9 7676",
    d: "M100.848,323.78l1.451.951-1.65,1.393-1.451-.951Z",
    transform: "translate(-75.647 -247.577)",
    fill: "#ce6f64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7677",
    "data-name": "Trac\\xE9 7677",
    d: "M138.244,102.563c.1,1.718.078,2.728.944,3.611A2.286,2.286,0,0,0,143.024,105c.37-1.543.138-4.093-1.543-4.778a2.347,2.347,0,0,0-3.237,2.339",
    transform: "translate(-105.474 -76.647)",
    fill: "#e4897b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7678",
    "data-name": "Trac\\xE9 7678",
    d: "M129.523,96.007c.427,1.566,1.433,3.37,2.732,3.485,1.616.142,2.345-1.526,2.557-3.251.968-.663.459-1.391,1.431-1.484,1.245-.119.848-2.4-.794-2.765,0,0,.549,1.027-.6.509a6.661,6.661,0,0,0-3.526-.612s1.471.735.032,1.064-1.869,1.216-1.207,1.753a1,1,0,0,0-.622,1.3",
    transform: "translate(-98.774 -70.392)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7679",
    "data-name": "Trac\\xE9 7679",
    d: "M147.935,109.6a1.944,1.944,0,0,0,.487,1.15c.378.416.773.157.839-.35.06-.457-.064-1.224-.526-1.453s-.832.139-.8.653",
    transform: "translate(-112.88 -83.399)",
    fill: "#e4897b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7680",
    "data-name": "Trac\\xE9 7680",
    d: "M110,200.807s1.69,12.238.359,17.141c-2.109,7.766-10.178,14.32-10.178,14.32l-2.735-1.793s6.87-5.535,7.711-12.034c.756-5.839-1.141-12.9-1.141-17.634Z",
    transform: "translate(-74.312 -153.629)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_809",
    "data-name": "Groupe 809",
    transform: "translate(23.138 47.178)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_808",
    "data-name": "Groupe 808"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_807",
    "data-name": "Groupe 807",
    clipPath: "url(#clip-path-19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7681",
    "data-name": "Trac\\xE9 7681",
    d: "M110,200.807s1.69,12.238.359,17.141c-2.109,7.766-10.178,14.32-10.178,14.32l-2.735-1.793s6.87-5.535,7.711-12.034c.756-5.839-1.141-12.9-1.141-17.634Z",
    transform: "translate(-97.45 -200.807)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7682",
    "data-name": "Trac\\xE9 7682",
    d: "M148.81,225.866a11.424,11.424,0,0,0-1.48-1.421,118.728,118.728,0,0,1,.262,14.037,18.034,18.034,0,0,0,.878-2.474c.649-2.393.581-6.531.34-10.142",
    transform: "translate(-112.419 -171.688)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_812",
    "data-name": "Groupe 812",
    transform: "translate(34.911 52.757)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_811",
    "data-name": "Groupe 811"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_810",
    "data-name": "Groupe 810",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7683",
    "data-name": "Trac\\xE9 7683",
    d: "M148.81,225.866a11.424,11.424,0,0,0-1.48-1.421,118.728,118.728,0,0,1,.262,14.037,18.034,18.034,0,0,0,.878-2.474c.649-2.393.581-6.531.34-10.142",
    transform: "translate(-147.33 -224.445)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7684",
    "data-name": "Trac\\xE9 7684",
    d: "M100.609,324.909c.011.007-1.059.7-1.059.7l-2.989-1.958.932-.781Z",
    transform: "translate(-73.633 -246.88)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_815",
    "data-name": "Groupe 815",
    transform: "translate(22.929 75.987)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_814",
    "data-name": "Groupe 814"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_813",
    "data-name": "Groupe 813",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7685",
    "data-name": "Trac\\xE9 7685",
    d: "M100.609,324.909c.011.007-1.059.7-1.059.7l-2.989-1.958.932-.781Z",
    transform: "translate(-96.562 -322.867)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7686",
    "data-name": "Trac\\xE9 7686",
    d: "M144.846,200.807s2.612,11.07,2.8,16.358c.206,5.93-1.863,19.918-1.863,19.918h-2.937s-.362-14.1-.492-19.5c-.143-5.889-3.6-16.778-3.6-16.778Z",
    transform: "translate(-105.864 -153.629)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_818",
    "data-name": "Groupe 818",
    transform: "translate(32.886 47.178)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_817",
    "data-name": "Groupe 817"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_816",
    "data-name": "Groupe 816",
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7687",
    "data-name": "Trac\\xE9 7687",
    d: "M144.846,200.807s2.612,11.07,2.8,16.358c.206,5.93-1.863,19.918-1.863,19.918h-2.937s-.362-14.1-.492-19.5c-.143-5.889-3.6-16.778-3.6-16.778Z",
    transform: "translate(-138.75 -200.807)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7688",
    "data-name": "Trac\\xE9 7688",
    d: "M158.509,349.542c.013,0-.166,1.22-.166,1.22h-3.573l-.1-1.088Z",
    transform: "translate(-118.029 -267.259)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_821",
    "data-name": "Groupe 821",
    transform: "translate(36.645 82.283)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_820",
    "data-name": "Groupe 820"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_819",
    "data-name": "Groupe 819",
    clipPath: "url(#clip-path-23)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7689",
    "data-name": "Trac\\xE9 7689",
    d: "M158.509,349.542c.013,0-.166,1.22-.166,1.22h-3.573l-.1-1.088Z",
    transform: "translate(-154.674 -349.542)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7690",
    "data-name": "Trac\\xE9 7690",
    d: "M351.94,155.731c.2.189.358.35.525.53s.321.355.475.536c.309.362.6.74.873,1.124a18.007,18.007,0,0,1,1.481,2.421l.088.172a2.042,2.042,0,0,1,.106.26,2.123,2.123,0,0,1,.1.534,2.637,2.637,0,0,1-.129.946,4.8,4.8,0,0,1-.757,1.4,10.126,10.126,0,0,1-2.078,2l-.589-.675c.278-.321.566-.669.822-1.016a8.735,8.735,0,0,0,.7-1.063,3.755,3.755,0,0,0,.429-1.043,1.045,1.045,0,0,0,.015-.4.5.5,0,0,0-.041-.13.406.406,0,0,0-.03-.052l-.078-.126a24.669,24.669,0,0,0-1.479-2.151c-.263-.346-.544-.679-.825-1.008-.14-.165-.283-.326-.428-.485s-.3-.321-.425-.447Z",
    transform: "translate(-267.789 -119.192)",
    fill: "#e4897b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7691",
    "data-name": "Trac\\xE9 7691",
    d: "M351.656,193.1l-1.763-.289.921,1.545s1.135-.039,1.46-.7Z",
    transform: "translate(-267.171 -147.52)",
    fill: "#e4897b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7692",
    "data-name": "Trac\\xE9 7692",
    d: "M344.369,193.525l.841,1.252,1.384-.422-.921-1.545Z",
    transform: "translate(-262.951 -147.52)",
    fill: "#e4897b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7693",
    "data-name": "Trac\\xE9 7693",
    d: "M355.684,363.276a.508.508,0,0,1-.337-.092.239.239,0,0,1-.069-.223.142.142,0,0,1,.083-.118c.206-.092.743.254.8.293a.042.042,0,0,1-.013.076,2.148,2.148,0,0,1-.467.064m-.236-.366a.135.135,0,0,0-.053.009.06.06,0,0,0-.035.053.157.157,0,0,0,.043.149.838.838,0,0,0,.629.031,1.56,1.56,0,0,0-.584-.242",
    transform: "translate(-271.282 -277.409)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7694",
    "data-name": "Trac\\xE9 7694",
    d: "M357.413,361.869a.042.042,0,0,1-.021-.005c-.169-.1-.49-.477-.451-.677a.146.146,0,0,1,.141-.117.211.211,0,0,1,.177.056c.192.17.195.679.195.7a.042.042,0,0,1-.021.036.04.04,0,0,1-.021.006m-.3-.717h-.019c-.054.007-.065.03-.069.05-.025.121.176.408.344.542a.959.959,0,0,0-.164-.557.137.137,0,0,0-.093-.037",
    transform: "translate(-272.554 -276.064)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7695",
    "data-name": "Trac\\xE9 7695",
    d: "M321.285,363.275a.663.663,0,0,1-.429-.109.232.232,0,0,1-.076-.2.135.135,0,0,1,.071-.111c.219-.121.922.241,1,.283a.042.042,0,0,1-.011.078,3,3,0,0,1-.556.063m-.315-.366a.166.166,0,0,0-.078.015.052.052,0,0,0-.028.045.151.151,0,0,0,.048.134,1.13,1.13,0,0,0,.79.048,2.28,2.28,0,0,0-.733-.243",
    transform: "translate(-244.929 -277.408)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7696",
    "data-name": "Trac\\xE9 7696",
    d: "M323.258,361.871a.044.044,0,0,1-.017,0c-.211-.1-.628-.477-.6-.677.008-.047.041-.106.157-.118a.3.3,0,0,1,.232.072,1.182,1.182,0,0,1,.265.681.042.042,0,0,1-.017.038.043.043,0,0,1-.024.008m-.421-.717h-.025c-.077.008-.081.038-.083.048-.02.12.263.42.478.551a.969.969,0,0,0-.225-.546.219.219,0,0,0-.145-.055",
    transform: "translate(-246.354 -276.066)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7697",
    "data-name": "Trac\\xE9 7697",
    d: "M327.713,132.741c-.068,1.067-.253,3.235.566,3.835,0,0-.147,1.093-2.08,1.346-2.126.278-1.154-.923-1.154-.923,1.124-.429.982-1.286.674-2.068Z",
    transform: "translate(-248.018 -101.629)",
    fill: "#e4897b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7698",
    "data-name": "Trac\\xE9 7698",
    d: "M316.133,123.329a.084.084,0,0,1-.063-.029.666.666,0,0,0-.555-.241.081.081,0,0,1-.095-.072.084.084,0,0,1,.071-.095.832.832,0,0,1,.7.3.084.084,0,0,1-.063.139",
    transform: "translate(-240.835 -94.102)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7699",
    "data-name": "Trac\\xE9 7699",
    d: "M315.633,129.183a3.811,3.811,0,0,1-.386.969.613.613,0,0,0,.517.029Z",
    transform: "translate(-240.703 -98.91)",
    fill: "#de5753"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7700",
    "data-name": "Trac\\xE9 7700",
    d: "M316.19,127.322c.018.141-.042.266-.134.278s-.182-.093-.2-.234.042-.266.134-.278.182.093.2.234",
    transform: "translate(-241.165 -97.309)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7701",
    "data-name": "Trac\\xE9 7701",
    d: "M315.47,126.928l-.353-.054s.209.243.353.054",
    transform: "translate(-240.603 -97.146)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7702",
    "data-name": "Trac\\xE9 7702",
    d: "M327.379,351.027H325.61l-.118-4.1h1.769Z",
    transform: "translate(-248.53 -265.264)",
    fill: "#e4897b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7703",
    "data-name": "Trac\\xE9 7703",
    d: "M359.969,351.027H358.2l-.569-4.1H359.4Z",
    transform: "translate(-273.083 -265.264)",
    fill: "#e4897b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7704",
    "data-name": "Trac\\xE9 7704",
    d: "M351.337,363.418h1.987a.14.14,0,0,1,.141.121l.226,1.572a.284.284,0,0,1-.283.314c-.693-.012-1.027-.052-1.9-.052-.538,0-1.323.056-2.066.056-.726,0-.782-.734-.473-.8a3.463,3.463,0,0,0,2.072-1.1.461.461,0,0,1,.3-.109",
    transform: "translate(-266.33 -277.86)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7705",
    "data-name": "Trac\\xE9 7705",
    d: "M316.44,363.418h1.987a.14.14,0,0,1,.141.121l.226,1.572a.284.284,0,0,1-.283.314c-.693-.012-1.027-.052-1.9-.052-.538,0-1.65.056-2.392.056-.726,0-.782-.734-.473-.8a4.8,4.8,0,0,0,2.4-1.1.462.462,0,0,1,.3-.109",
    transform: "translate(-239.42 -277.86)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7706",
    "data-name": "Trac\\xE9 7706",
    d: "M325.494,346.936l.061,2.111h1.769l-.06-2.111Z",
    transform: "translate(-248.531 -265.268)",
    fill: "#ce6f64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7707",
    "data-name": "Trac\\xE9 7707",
    d: "M359.4,346.936h-1.77l.294,2.111h1.77Z",
    transform: "translate(-273.083 -265.268)",
    fill: "#ce6f64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7708",
    "data-name": "Trac\\xE9 7708",
    d: "M321.307,116.063c.121,1.751.209,2.49-.552,3.5a2.243,2.243,0,0,1-3.963-.4c-.577-1.512-.678-4.122.933-5.036a2.394,2.394,0,0,1,3.582,1.94",
    transform: "translate(-241.589 -87.158)",
    fill: "#e4897b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7709",
    "data-name": "Trac\\xE9 7709",
    d: "M320.9,115.418c.984.548,1.711-.8,1.711-.8s-1.76.191-1.6-.857c.209-1.39-.787-3.08-3.285-2.864-.138.012-.272.03-.4.051a1.285,1.285,0,0,0-1.553.358,1.324,1.324,0,0,0-1.016,2.021,1.057,1.057,0,0,1,.209-.346c.053.653.626,1.692,1.339,1.76.154.9-.441,1.932-.23,2.865.3,1.348,2.577,1.662,2.577,1.662a.983.983,0,0,1,.133-1.039,2.694,2.694,0,0,0,2.561.016c-1.052-.393-.734-1.092-.734-1.092a1.533,1.533,0,0,0,2-.728,1.816,1.816,0,0,1-1.711-1",
    transform: "translate(-240.162 -84.887)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7710",
    "data-name": "Trac\\xE9 7710",
    d: "M320.76,126.571a1.282,1.282,0,0,1-.354.913c-.313.323-.7.1-.8-.316-.092-.372-.04-.989.366-1.157a.576.576,0,0,1,.786.56",
    transform: "translate(-244.004 -96.452)",
    fill: "#e4897b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7711",
    "data-name": "Trac\\xE9 7711",
    d: "M330.839,195.447s.45,11.649,1.515,18.491c.86,5.526,4.676,18.443,4.676,18.443h2.412s-1.988-12.475-2.425-17.94c-1.1-13.83,1.762-16.8-.936-19.68Z",
    transform: "translate(-252.615 -149.01)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7712",
    "data-name": "Trac\\xE9 7712",
    d: "M333.788,213.261s-1.09-.189-1.728,1.888c.241,3.935.64,9.155,1.227,12.918.13.838.328,1.848.571,2.955-.46-6.647-.071-17.761-.071-17.761",
    transform: "translate(-253.547 -163.14)",
    fill: "#161f33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7713",
    "data-name": "Trac\\xE9 7713",
    d: "M316.794,196.5s-1.988,12.888-1.872,18.282c.12,5.61,2.176,18.406,2.176,18.406h2.392s-.379-12.468-.167-17.978c.23-6.007,2.687-19.393,2.687-19.393Z",
    transform: "translate(-240.451 -149.818)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7714",
    "data-name": "Trac\\xE9 7714",
    d: "M357.58,351.138h-3.206l-.25-1.076,3.434.025Z",
    transform: "translate(-270.404 -267.656)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_824",
    "data-name": "Groupe 824",
    transform: "translate(83.72 82.406)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_823",
    "data-name": "Groupe 823"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_822",
    "data-name": "Groupe 822",
    clipPath: "url(#clip-path-24)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7715",
    "data-name": "Trac\\xE9 7715",
    d: "M357.58,351.138h-3.206l-.25-1.076,3.434.025Z",
    transform: "translate(-354.124 -350.062)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7716",
    "data-name": "Trac\\xE9 7716",
    d: "M346.923,148.982c.922.088,2.324,2.71,2.324,2.71l-2.33,1.788s-1.929-1.692-1.7-2.643c.239-.99.819-1.939,1.7-1.855",
    transform: "translate(-263.586 -114.032)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_827",
    "data-name": "Groupe 827",
    transform: "translate(81.614 34.944)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_826",
    "data-name": "Groupe 826"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_825",
    "data-name": "Groupe 825",
    clipPath: "url(#clip-path-25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7717",
    "data-name": "Trac\\xE9 7717",
    d: "M346.923,148.982c.922.088,2.324,2.71,2.324,2.71l-2.33,1.788s-1.929-1.692-1.7-2.643c.239-.99.819-1.939,1.7-1.855",
    transform: "translate(-345.199 -148.977)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7718",
    "data-name": "Trac\\xE9 7718",
    d: "M346.227,153.5a2.39,2.39,0,0,0-.722-.08,3.99,3.99,0,0,0-.286.807c-.229.951,1.7,2.644,1.7,2.644l.172-.132Z",
    transform: "translate(-263.586 -117.425)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_830",
    "data-name": "Groupe 830",
    transform: "translate(81.614 35.992)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_829",
    "data-name": "Groupe 829"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_828",
    "data-name": "Groupe 828",
    clipPath: "url(#clip-path-26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7719",
    "data-name": "Trac\\xE9 7719",
    d: "M346.227,153.5a2.39,2.39,0,0,0-.722-.08,3.99,3.99,0,0,0-.286.807c-.229.951,1.7,2.644,1.7,2.644l.172-.132Z",
    transform: "translate(-345.2 -153.418)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7720",
    "data-name": "Trac\\xE9 7720",
    d: "M307.384,162.184c-.673,1.7-1.381,3.433-1.945,5.14-.036.107-.069.213-.1.318l-.08.262a.425.425,0,0,0,0,.245,1.75,1.75,0,0,0,.611.731,9.877,9.877,0,0,0,2.286,1.225l-.211.87a8.2,8.2,0,0,1-2.853-.931,3.044,3.044,0,0,1-1.271-1.288,1.978,1.978,0,0,1-.165-1.125c.006-.047.016-.093.025-.139l.022-.1.042-.179c.027-.12.056-.239.087-.356.242-.939.538-1.839.855-2.731s.652-1.767,1.028-2.642Z",
    transform: "translate(-231.831 -123.59)",
    fill: "#e4897b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7721",
    "data-name": "Trac\\xE9 7721",
    d: "M313.143,150.068s-.8.4,2.223,10.475l7.123-.932c-.5-2.883-.736-4.671-.129-10.8a21.216,21.216,0,0,0-3.077,0,22.845,22.845,0,0,0-3.234.423c-1.372.308-2.906.837-2.906.837",
    transform: "translate(-239.023 -113.86)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_833",
    "data-name": "Groupe 833",
    transform: "translate(74.025 34.891)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_832",
    "data-name": "Groupe 832"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_831",
    "data-name": "Groupe 831",
    clipPath: "url(#clip-path-27)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7722",
    "data-name": "Trac\\xE9 7722",
    d: "M313.143,150.068s-.8.4,2.223,10.475l7.123-.932c-.5-2.883-.736-4.671-.129-10.8a21.216,21.216,0,0,0-3.077,0,22.845,22.845,0,0,0-3.234.423c-1.372.308-2.906.837-2.906.837",
    transform: "translate(-313.048 -148.752)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7723",
    "data-name": "Trac\\xE9 7723",
    d: "M329.159,192.8l.4.6c.031.046-.021.1-.1.115l-7.47.977c-.064.008-.122-.016-.131-.056l-.148-.629c-.01-.044.041-.088.111-.1l7.213-.944a.13.13,0,0,1,.123.038",
    transform: "translate(-245.642 -147.483)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_836",
    "data-name": "Groupe 836",
    transform: "translate(76.07 45.279)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_835",
    "data-name": "Groupe 835"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_834",
    "data-name": "Groupe 834",
    clipPath: "url(#clip-path-28)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7724",
    "data-name": "Trac\\xE9 7724",
    d: "M329.159,192.8l.4.6c.031.046-.021.1-.1.115l-7.47.977c-.064.008-.122-.016-.131-.056l-.148-.629c-.01-.044.041-.088.111-.1l7.213-.944a.13.13,0,0,1,.123.038",
    transform: "translate(-321.712 -192.762)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7725",
    "data-name": "Trac\\xE9 7725",
    d: "M348.7,193.876l.193-.025c.038,0,.065-.029.059-.053l-.2-.816c-.006-.024-.042-.039-.08-.034l-.193.025c-.039,0-.065.029-.059.052l.2.817c.006.024.042.039.08.034",
    transform: "translate(-266.048 -147.624)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7726",
    "data-name": "Trac\\xE9 7726",
    d: "M328.864,196.471l.193-.025c.039,0,.065-.029.059-.053l-.2-.816c-.006-.024-.042-.039-.08-.034l-.193.025c-.038,0-.065.029-.06.052l.2.817c.006.024.042.039.08.034",
    transform: "translate(-250.892 -149.606)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7727",
    "data-name": "Trac\\xE9 7727",
    d: "M314.86,168.232c.2.911.479,2.065.876,3.526l.087-3.7Z",
    transform: "translate(-240.407 -128.608)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_839",
    "data-name": "Groupe 839",
    transform: "translate(74.453 39.447)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_838",
    "data-name": "Groupe 838"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_837",
    "data-name": "Groupe 837",
    clipPath: "url(#clip-path-29)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7728",
    "data-name": "Trac\\xE9 7728",
    d: "M314.86,168.232c.2.911.479,2.065.876,3.526l.087-3.7Z",
    transform: "translate(-314.86 -168.055)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7729",
    "data-name": "Trac\\xE9 7729",
    d: "M308.124,153.555c-.886.355-1.646,3.384-1.646,3.384l3.044,1.482s1.473-3.7.813-4.426a1.633,1.633,0,0,0-2.211-.441",
    transform: "translate(-234.003 -117.348)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_842",
    "data-name": "Groupe 842",
    transform: "translate(72.475 35.969)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_841",
    "data-name": "Groupe 841"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_840",
    "data-name": "Groupe 840",
    clipPath: "url(#clip-path-30)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7730",
    "data-name": "Trac\\xE9 7730",
    d: "M308.124,153.555c-.886.355-1.646,3.384-1.646,3.384l3.044,1.482s1.473-3.7.813-4.426a1.633,1.633,0,0,0-2.211-.441",
    transform: "translate(-306.478 -153.317)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7731",
    "data-name": "Trac\\xE9 7731",
    d: "M324.83,351.138h-3.206l-.25-1.076,3.57.025Z",
    transform: "translate(-245.384 -267.656)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_845",
    "data-name": "Groupe 845",
    transform: "translate(75.99 82.406)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_844",
    "data-name": "Groupe 844"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_843",
    "data-name": "Groupe 843",
    clipPath: "url(#clip-path-31)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7732",
    "data-name": "Trac\\xE9 7732",
    d: "M324.83,351.138h-3.206l-.25-1.076,3.57.025Z",
    transform: "translate(-321.374 -350.062)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7733",
    "data-name": "Trac\\xE9 7733",
    d: "M320.444,196.285l-.257-.106a.386.386,0,0,0-.528.415l.186,1.23a.421.421,0,0,0,.557.335.958.958,0,0,0,.259-.144.7.7,0,0,0,.254-.586l-.024-.51a.723.723,0,0,0-.447-.634",
    transform: "translate(-244.069 -150.071)",
    fill: "#e4897b"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerif);
export default __webpack_public_path__ + "static/media/Verif.2c1c27a0bd67723ae60b349f03aec78b.svg";
export { ForwardRef as ReactComponent };